module.exports = __webpack_public_path__ + "static/media/paserg-border-text.87986678.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/images/paserg/paserg-border-text.png
// module id = 214
// module chunks = 0